export default function(update) {
  return new Array(update.length);
}



//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/d3-selection/src/selection/sparse.js
// module id = ../../../../d3-selection/src/selection/sparse.js
// module chunks = 4